module.exports = "//public.getcloudapp.com/packs/media/images/gift-68218f352a69059c986526156b43a19d.svg";